import * as VideoPlayerType from 'common/constants/video-player-type';
import ASVideoPlayer from 'as-player';
// import Environment from 'common/utils/environment';
import styles from './styles.less';
import { observer, propTypes } from 'mobx-react';
import { uniqueID } from 'lodash';


@observer
class ASVPComponent extends React.Component {
    static propTypes = {
        autoplay: React.PropTypes.bool.isRequired,
        darkMode: React.PropTypes.bool.isRequired,
        onVideoComplete: React.PropTypes.func,
        onVideoEnded: React.PropTypes.func,
        onVideoFinished: React.PropTypes.func.isRequired,
        onVideoPause: React.PropTypes.func,
        onVideoStart: React.PropTypes.func,
        video: propTypes.objectOrObservableObject
    };

    static defaultProps = {
        autoplay: true,
        darkMode: true
    };

    constructor(props) {
        super(props);
        this.id = uniqueID('asvp');
    }

    componentDidMount() {
        this.createPlayer();
    }

    componentDidUpdate(prevProps) {
        if (!this.player) {
            this.createPlayer();
        } else if (!this.props.video) {
            this.pause();
        } else if (prevProps.video !== this.props.video) {
            this.play();
        }
    }

    componentWillUnmount() {
        this.destroyPlayingListener();
        this.destroyPlayer();
    }

    render() {
        return (
            <div
                className={ cx(styles.asvp, this.props.className, { 'dark-mode': this.props.darkMode }) }
                style={ this.props.style }>
                <video
                    id={ this.id }
                    ref='player'
                    src='http://z.cdn.turner.com/xslo/cvp/assets/video/blank.mp4'>
                </video>
            </div>
        );
    }

    createPlayer() {
        if (this.player || !this.props.video) {
            return;
        }
        this.player = new ASVideoPlayer(this.id, this.props.video.id, { autoplay: this.props.autoplay });
        this.player.registerEvent('ended', this.handleVideoEnded);
        // UNCOMMENT AFTER ASVP FW UPDATE IS RELEASED
        // this.player.registerEvent('finished', this.handleVideoFinished);
        // UNCOMMENT AFTER ASVP FW UPDATE IS RELEASED
        this.player.registerEvent('paused', this.handleVideoPaused);
        this.createPlayingListener();
    }

    createPlayingListener() {
        this.destroyPlayingListener();
        this.playingListener = this.player.registerEvent('playing', this.handleVideoStarted);
    }

    destroyPlayer() {
        if (this.player) {
            this.player.destroy(false);
        }
        this.player = null;
    }

    destroyPlayingListener() {
        if (this.playingListener) {
            this.playingListener();
        }
        this.playingListener = null;
    }

    pause() {
        if (this.player) {
            this.player.getPlayer().pause();
        }
    }

    play() {
        if (!this.player || !this.props.video) {
            return;
        }
        this.createPlayingListener();
        this.player.setVideo(this.props.video.id, { success: () => {
            const player = this.player.getPlayer();
            player.currentTime(0);
            player.play();
        }});
    }

    /*============================================
    =            Video Event Handlers            =
    ============================================*/

    handleVideoEnded = (eventData) => {
        this.props.onVideoComplete && this.props.onVideoComplete(this.props.video, eventData, VideoPlayerType.ASVP);
        this.props.onVideoEnded && this.props.onVideoEnded(this.props.video, eventData, VideoPlayerType.ASVP);

        // WILL FIRE INDEPENDENTLY BELOW WITH ASVP FW UPDATE, REMOVE THIS AFTER UPDATE
        this.props.onVideoFinished && this.props.onVideoFinished(this.props.video, eventData, VideoPlayerType.ASVP);
        // WILL FIRE INDEPENDENTLY BELOW WITH ASVP FW UPDATE, REMOVE THIS AFTER UPDATE
    };

    handleVideoFinished = (eventData) => {
        this.props.onVideoFinished && this.props.onVideoFinished(this.props.video, eventData, VideoPlayerType.ASVP);
    };

    handleVideoPaused = (eventData) => {
        this.props.onVideoPause && this.props.onVideoPause(this.props.video, eventData, VideoPlayerType.ASVP);
    };

    handleVideoStarted = (eventData) => {
        this.destroyPlayingListener();
        this.props.onVideoStart && this.props.onVideoStart(this.props.video, eventData, VideoPlayerType.ASVP);
    };

}


export default ASVPComponent;



/** WEBPACK FOOTER **
 ** ./src/common/components/video-player/asvp.js
 **/